import "babel-polyfill";
import Vue from "vue";
import axios from "axios";
import store from "./store";
import router from "./router";
import "./registerServiceWorker";
import ElementUI from "element-ui";
import VueCropper from "vue-cropper";
import VueClipboard from "vue-clipboard2";
import "@/utils/mixin";
import "../public/style/no_number.css";
// import "@/utils/utilss";
import { setWebToken } from "@/utils/autoToken";
import "element-ui/lib/theme-chalk/index.css";
import Print from "vue-print-nb";
import { rewirteLog } from "@/utils/public";
// import "lib-flexible";//适配,如有需要引入
// 引用创建好的指令
import directives from "./directives";
import LuckDraw from "vue-luck-draw";
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import App from "./App.vue";
Vue.use(VueViewer);
// 全局注册指令
Vue.use(directives);
Vue.use(ElementUI);
Vue.use(VueCropper);
Vue.use(VueClipboard);
Vue.use(Print);
Vue.use(LuckDraw);
Vue.filter("dataFormat", originVal => {
  if (!originVal) {
    return "";
  }
  const dt = new Date(originVal * 1000);
  const y = dt.getFullYear();
  const m = (dt.getMonth() + 1 + "").padStart(2, "0");
  const d = (dt.getDate() + "").padStart(2, "0");
  const hh = (dt.getHours() + "").padStart(2, "0");
  const mm = (dt.getMinutes() + "").padStart(2, "0");
  const ss = (dt.getSeconds() + "").padStart(2, "0");
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
});

//设置 环境 test:测试 online:正式
let status = "online";
rewirteLog();
let publicData = {
  a_copyright: "智联同城科技",
  a_mobile: "18888217968",
  a_title: "智联同城",
  u_url: "https://www.58zltc.com/logo.png"
};
localStorage.setItem("baseStatus", status);
localStorage.setItem("publicData", JSON.stringify(publicData));
store.commit("SET_STATUS", status);
//设置 token
setWebToken(status);
// 全局使用axios
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

let vueThat = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
export default vueThat;
var data = {
  url: "123456",
  params: {
    a: 1,
    b: 2
  }
};
a(data);
function a(data) {
  console.log(`${data.url}${data.params ? "?" + data.params : ""}`);
}
